<template>
    <div>


      <el-form size="small" ref="form" :model="formData" label-width="180px"  :inline="true" :rules="rules">
        <el-form-item label="面试官" prop="interview_users">
            <el-select   placeholder="请选择" :multiple="true" v-model="formData.interview_users">
              <el-option
                  v-for="item in userList"
                  :key="item.user_app_id"
                  :label="item.nickname"
                  :value="item.user_app_id">
              </el-option>
            </el-select>
        </el-form-item>
  
        <el-form-item>
          <el-button type="primary" size="small"  @click="setInterviewUser">保存</el-button>
        </el-form-item>
      </el-form>


      <el-form size="small" ref="form2" :model="formData" label-width="180px"  :inline="true" :rules="rules">
        <el-form-item label="面试邀约人" prop="invite_users">
            <el-select   placeholder="请选择" :multiple="true" v-model="formData.invite_users">
              <el-option
                  v-for="item in userList"
                  :key="item.user_app_id"
                  :label="item.nickname"
                  :value="item.user_app_id">
              </el-option>
            </el-select>
        </el-form-item>
  
        <el-form-item>
          <el-button type="primary" size="small"  @click="setInviteUser">保存</el-button>
        </el-form-item>
      </el-form>


  </div>

  </template>
   <script>
   import ImageUpload from '@/components/ImageUpload';
   import urlConfig from '@/api/config'
   import { getTalent,postPurview,getPurview} from "@/api/common/index.js";

   export default {
     components: {
       ImageUpload
     },
   
     props: {
       // 值
       project_id: {
         type: String,
         default: "",
       },
      
     },
   
     data () {
       return {
         userList:[],
         uploadFileUrl:  urlConfig.prod.baseURL +"/web/file/Upload", // 上传的图片服务器地址
    
         formData:  {
           interview_users:[],
           invite_users:[],
           
         },
       
         rules: {
          interview_users: [
             { required: true, message: '请选择面试官', trigger: 'change' }
           ],
           invite_users: [
             { required: true, message: '请选择面试邀约人', trigger: 'blur' }
           ],
         
         }
   
       }
     },
   
     created(){
 
      
     },
     mounted () {
      if(this.$route.query&&this.$route.query.project_id){
        this.project_id=this.$route.query.project_id;
      }
      this.initUserList();
      this.getUsers(5);
      this.getUsers(6);
      
     },
     methods:{

       initUserList(){
        var that = this;
        getTalent({"type":2,"user_type":2}).then((response) => {
          console.log(response);
          if(response.code==200){
            that.userList=response.data;
          }else{
            that.$message.error(response.msg?response.msg:"请求错误");
          }
         
        });
      },
 
       

      //5 面试官 6 要约人
      getUsers(type){
        var that=this;
        var params={
          type:type,//项目管理
          purview_field:'projec_id',
          field_value:this.project_id,
        };
        
         // postPurview
            getPurview(params).then((response) => {
                console.log(response);
                if(response.code==200){
                  if(type==5){
                    response.data.forEach((item) => {
                      this.formData.interview_users.push(item.user_app_id)
                    });
                    
                  } 

                  if(type==6){

                    response.data.forEach((item) => {
                      this.formData.invite_users.push(item.user_app_id)
                    });

                  }
                }else{
                  this.$message({
                    message: response.msg?response.msg:"获取信息失败",
                  });
                }
              });
              
      },


     setInterviewUser(){
        var that=this;
        var params={
          user_app_ids:that.formData.interview_users.join(","),
          type:5,//面试官
          purview_field:'projec_id',
          field_value:this.project_id,
        };
        
         // postPurview
        this.$refs["form"].validate((valid) => {
            if (valid) {
              postPurview(params).then((response) => {
                  console.log(response);
                  if(response.code==200){
                    this.$message({
                      message: "提交成功",
                      type: 'success'

                    });
                  }else{
                    this.$message({
                      message: response.msg?response.msg:"提交失败",
                    });
                  }
                });
              
            } 
          });
      },

    setInviteUser(){
        var that=this;
        var params={
          user_app_ids:that.formData.invite_users.join(","),
          type:6,//面试邀约人
          purview_field:'projec_id',
          field_value:this.project_id,
        };
        
         // postPurview
        this.$refs["form2"].validate((valid) => {
            if (valid) {
              postPurview(params).then((response) => {
                  console.log(response);
                  if(response.code==200){
                    this.$message({
                      message: "提交成功",
                      type: 'success'

                    });
                  }else{
                    this.$message({
                      message: response.msg?response.msg:"提交失败",
                    });
                  }
                });
              
            } 
          });
      }
    }
  }
   </script>
   
   
   <style lang="scss" scoped>
 
   </style>